import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';
import useStyles from '../styles/CustomStyle'
import NumberFormat from 'react-number-format';

export default function BankInformation(props) {
  const classes = useStyles();

  const msg = "This is a required field";

  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);


  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  const getBankInfo = () => {
    if (props.bankType === "Bank") {
      return (
        <React.Fragment>
          <Grid item xs={12} sm={12}>
            <TextField
              id="fullName"
              name="account_holder_name"
              label="Account Holder's Name"
              value={props.stepContent.account_holder_name}
              onChange={handleChange}
              fullWidth
              autoComplete="fname"
              required
              error={props.error.account_holder_name}
              helperText={props.error.account_holder_name ?
                msg : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id="bank_account_number"
              name="bank_account_number"
              label="Bank Account Number"
              value={props.stepContent.bank_account_number}
              onChange={handleChange}
              fullWidth
              autoComplete="accNum"
              required
              error={props.error.bank_account_number}
              helperText={props.error.bank_account_number ?
                msg : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id="bank_name"
              name="bank_name"
              label="Bank Name"
              value={props.stepContent.bank_name}
              onChange={handleChange}
              fullWidth
              autoComplete="bank_name"
              required
              error={props.error.bank_name}
              helperText={props.error.bank_name ?
                msg : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Branch name"
              id="branch_name"
              name="branch_name"
              value={props.stepContent.branch_name}
              onChange={handleChange}
              // onChange={handleChangeEmail}
              fullWidth
              autoComplete="branch_name"
              required
              error={props.error.branch_name}
              helperText={props.error.branch_name ?
                msg : ""
              }
            />
          </Grid>
        </React.Fragment>
      )
    } else if (props.bankType === "Bkash") {
      return (
        <React.Fragment>
          <Grid item xs={12}>
            <FormControl className={classes.formControl} required error={props.error.bkash_id.isEmpty || props.error.bkash_id.invalid}>
              <NumberFormat
                error={props.error.bkash_id.isEmpty || props.error.bkash_id.invalid}
                name="phone"
                placeholder="Bkash Number"
                style={{
                  marginTop: 16,
                  width: "100%"
                }}
                customInput={TextField}
                format="+88###########"
                value={props.stepContent.bkash_id}
                onValueChange={(values) => {
                  handleChange(values.formattedValue, "bkash_id")
                }}
              />
              {
                props.error.bkash_id.isEmpty ?
                  <FormHelperText>
                    {msg}
                  </FormHelperText> : "" || props.error.bkash_id.invalid ? <FormHelperText>Invalid phone number</FormHelperText> : ""
              }
            </FormControl>
          </Grid>
        </React.Fragment>
      )
    } else if (props.bankType === "Rocket") {
      return (
        <React.Fragment>
          <Grid item xs={12}>
            <FormControl className={classes.formControl} required error={props.error.rocket_id.isEmpty || props.error.rocket_id.invalid}>
              <NumberFormat
                error={props.error.rocket_id.isEmpty || props.error.rocket_id.invalid}
                name="phone"
                placeholder="Rocket Number"
                style={{
                  marginTop: 16,
                  width: "100%"
                }}
                customInput={TextField}
                format="+88###########"
                value={props.stepContent.rocket_id}
                onValueChange={(values) => {
                  handleChange(values.formattedValue, "rocket_id")
                }}
              />
              {
                props.error.rocket_id.isEmpty ?
                  <FormHelperText>
                    {msg}
                  </FormHelperText> : "" || props.error.rocket_id.invalid ? <FormHelperText>Invalid phone number</FormHelperText> : ""
              }
            </FormControl>
          </Grid>
        </React.Fragment>
      )
    } else if (props.bankType === "Nagad") {
      return (
        <React.Fragment>
          <Grid item xs={12}>
            <FormControl className={classes.formControl} required error={props.error.nagad_id.isEmpty || props.error.nagad_id.invalid}>
              <NumberFormat
                error={props.error.nagad_id.isEmpty || props.error.nagad_id.invalid}
                name="phone"
                placeholder="Nagad Number"
                style={{
                  marginTop: 16,
                  width: "100%"
                }}
                customInput={TextField}
                format="+88###########"
                value={props.stepContent.nagad_id}
                onValueChange={(values) => {
                  handleChange(values.formattedValue, "nagad_id")
                }}
              />
              {
                props.error.nagad_id.isEmpty ?
                  <FormHelperText>
                    {msg}
                  </FormHelperText> : "" || props.error.nagad_id.invalid ? <FormHelperText>Invalid phone number</FormHelperText> : ""
              }
            </FormControl>
          </Grid>
        </React.Fragment>
      )
    }
  }


  const handleBankType = (e) => {
    props.setBankType(e.target.value)
  }

  const handleChange = (e, flag) => {
    if (flag === "bkash_id" || flag === "rocket_id" || "nagad_id") {
      props.setError({
        ...props.error,
        [flag]: {
          isEmpty: false,
          invalid: false
        }
      })
    } else {
      props.setError({
        ...props.error,
        [e.target.name]: false
      })
    }

    props.handleChange(e, flag)
  }

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl variant="outlined" className={classes.formControl} required >
            <InputLabel ref={inputLabel} id="banking-info">Select Account Type</InputLabel>
            <Select
              labelId="banking-info"
              id="banking-info"
              name="banking-info"
              value={props.bankType}
              onChange={handleBankType}
              labelWidth={labelWidth}
            >
              <MenuItem value="Bank">Bank</MenuItem>
              <MenuItem value="Bkash">Bkash</MenuItem>
              <MenuItem value="Rocket">Rocket</MenuItem>
              <MenuItem value="Nagad">Nagad</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {getBankInfo()}
      </Grid>
    </React.Fragment>
  );
}